import { combineReducers } from "redux";
import authReducer from "./authReducer";
import beneficiaryReducer from "./beneficiaryReducer";
import acTermReducer from "./AcTermReducer";
import acYearsReducer from "./AcYearsReducer";
import marksReducer from "./PerformanceReducer";
import insurancesReducer from "./InsuranceReducer";
import benInsurancesReducer from "./BenInsuranceReducer";
import assocciationReducer from "./AssocciationReducer";
import assoccMembersReducer from "./AssocciationsMembersReducer";
import profileReducer from "./AccountReducer";
import residentialsReducer from "./ResidencesReducer";
import benHomesReducer from "./BeneficiriesHomeReducer";
import ubudeheCategoriesReducer from "./UbudeheCategoryReducer";
import categoriesReducer from "./CategoryReduder";
import hhdsReducer from "./HhdReducer";
import beneficiaryParentsReducer from "./ParentsReducer";
import beneficiaryCaregiversReducer from "./CaregiversReducer";
import lettersReducer from "./LetterReducer";
import schoolsReducer from "./SchoolReducer";
import fundsReducer from "./FundReducer";
import fundsTypeReducer from "./FundTypesReducer";
import benSchoolsReducer from "./BeneficiriesSchoolReducer";
import fundedBeneficiries from "./BenGotFundsReducer";
import stockReducer from "./StockReducer";
import userReducer from "./UserReducer";
import productReducer from "./StockProductsReducer";
import healthTestReducer from "./HtestReducer";
import saturdayStudyReducer from "./SstudyReducer";
import meetingReducer from "./MeetingReducer";
import visitReducer from "./VisitReducer";
import htestAttendeesReducer from "./HtestAttendeeReducer";
import meetingAttendeesReducer from "./MeetingAttendeeReducer";
import visitAttendeesReducer from "./VisitAttendeeReducer";
import satStudyAttendeesReducer from "./SaturdayStudyAttendeeReducer";
import benProfileReducer from "./BenProfileReducer";
import benPropetiesReducer from "./BenPropertiesReducer";
import propertyReducer from "./PropertiesReducer";
import benGroupsReducer from "./BenGroupReducer";
import groupReducer from "./GroupReducer";
import yearEventReducer from "./YearEventReducer";
import assocciationAssetReducer from "./AssocciationAssetReducer";
import assocciationReportReducer from "./AssoccMonthlyReportReducer";
import loaderReducer from "./LoadersReducer";
const rootReducer = combineReducers({
  auth: authReducer,
  beneficiries: beneficiaryReducer,
  acYears: acYearsReducer,
  acTerms: acTermReducer,
  benMarks: marksReducer,
  insurances: insurancesReducer,
  benInsurances: benInsurancesReducer,
  stateOfAssociations: assocciationReducer,
  assocciationMembers: assoccMembersReducer,
  stateOfProfiles: profileReducer,
  residentials: residentialsReducer,
  benHomes: benHomesReducer,
  ubudeheCategories: ubudeheCategoriesReducer,
  categories: categoriesReducer,
  beneficiaryHhds: hhdsReducer,
  beneficiaryParents: beneficiaryParentsReducer,
  beneficiaryCaregivers: beneficiaryCaregiversReducer,
  letters: lettersReducer,
  schools: schoolsReducer,
  fundsState: fundsReducer,
  fundsTypes: fundsTypeReducer,
  beneficiriesSchools: benSchoolsReducer,
  fundedBeneficiries: fundedBeneficiries,
  stockState: stockReducer,
  usersState: userReducer,
  productsState: productReducer,
  healthTestsEventState: healthTestReducer,
  saturdayStudiesEventState: saturdayStudyReducer,
  meetingState: meetingReducer,
  visitState: visitReducer,
  healthTestAttendeesState: htestAttendeesReducer,
  meetingAttendeesState: meetingAttendeesReducer,
  visitAttendeesState: visitAttendeesReducer,
  satStudyAttendeesState: satStudyAttendeesReducer,
  benProfileState: benProfileReducer,
  propetiesState: propertyReducer,
  benPropetiesState: benPropetiesReducer,
  benGroupsState: benGroupsReducer,
  groupState: groupReducer,
  yearEventState: yearEventReducer,
  loadersState: loaderReducer,
  assocciationAssets: assocciationAssetReducer,
  assocciationReports: assocciationReportReducer,
});

export default rootReducer;
